import React from 'react';
import { IOrderHistoryResources } from '../order-history.props.autogenerated';

export interface IModalFooterProps {
    className: string;
    resources: IOrderHistoryResources;
    onClose: () => void;
    onExport: () => void;
}

export const ModalFooter: React.FC<IModalFooterProps> = ({ className, resources, onClose, onExport }) => {
    return (
        <div className={`${className}__modal-footer-wrapper`}>
            <button
                aria-label={resources.orderHistoryExcelConfigurationCancelBtnTitle}
                title={resources.orderHistoryExcelConfigurationCancelBtnTitle}
                className={`${className}__cancel-btn msc-cta__secondary`}
                onClick={onClose}
            >
                {resources.orderHistoryExcelConfigurationCancelBtnTitle}
            </button>
            <button
                className={`${className}__export-btn`}
                aria-label={resources.orderHistoryExcelConfigurationSaveAndExportBtnTitle}
                title={resources.orderHistoryExcelConfigurationSaveAndExportBtnTitle}
                onClick={onExport}
            >
                <span className={`${className}__export-btn-icon`}></span>
                {resources.orderHistoryExcelConfigurationSaveAndExportBtnTitle}
            </button>
        </div>
    );
};
